var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEraser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2497 19.4844H12.2194L15.4753 16.2285L15.4768 16.2271L15.4782 16.2256L20.7801 10.9237C21.2014 10.5014 21.438 9.92925 21.438 9.33273C21.438 8.73621 21.2014 8.16405 20.7801 7.74173L16.5375 3.49908C16.1155 3.07713 15.5432 2.84009 14.9465 2.84009C14.3497 2.84009 13.7774 3.07713 13.3555 3.49908L8.05306 8.8015L8.0521 8.80237L8.05123 8.80333L2.74884 14.1057C2.32689 14.5277 2.08984 15.1 2.08984 15.6967C2.08984 16.2935 2.32689 16.8658 2.74884 17.2878L6.22591 20.7647C6.36659 20.9054 6.55736 20.9844 6.75627 20.9844H20.2497C20.4486 20.9844 20.6394 20.9054 20.78 20.7647C20.9207 20.6241 20.9997 20.4333 20.9997 20.2344C20.9997 20.0355 20.9207 19.8447 20.78 19.704C20.6394 19.5634 20.4486 19.4844 20.2497 19.4844ZM14.4162 4.55981C14.4858 4.49015 14.5685 4.4349 14.6595 4.39719C14.7504 4.35949 14.848 4.34009 14.9465 4.34009C15.0449 4.34009 15.1425 4.35949 15.2334 4.39719C15.3244 4.4349 15.4071 4.49015 15.4767 4.55981L19.7194 8.80246C19.8598 8.94322 19.9387 9.13394 19.9387 9.33278C19.9387 9.53162 19.8598 9.72234 19.7194 9.8631L14.9465 14.636L9.64324 9.33278L14.4162 4.55981Z",
    fill: "#7C6A8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraser);
export default __webpack_public_path__ + "static/media/Eraser.7a630871aea3766ff009307786111128.svg";
export { ForwardRef as ReactComponent };